package music.jammers.client.shared.event.presentation.viewmodel

import kotlinx.datetime.LocalDateTime
import music.jammers.client.shared.event.domain.model.ValidationError
import music.jammers.client.shared.event.domain.model.ValidationErrorValue
import music.jammers.shared.event.domain.model.CardInfo
import music.jammers.shared.event.domain.model.EventInstrument

data class EditEventState(
    val progress: Boolean = true,
    val eventId: Long = 0,
    val title: String = "",
    val description: String = "",
    val date: LocalDateTime? = null,
    val genre: String = "",
    val spot: String = "",
    val songsCount: String = "",
    val appliesPerPerson: String = "",
    val selectedInstruments: List<EventInstrument> = emptyList(),
    val bottomNavigationOpen: Boolean = false,
    val error: Throwable? = null,
    val deleteEventDialogOpened: Boolean = false,
    val cardInfo: CardInfo? = null,
)

internal data class EditEventValidationState(
    private val validationErrorMap: Map<String, ValidationError> = mutableMapOf(),
) {

    val errors: Map<String, ValidationError> get() = validationErrorMap

    fun addError(error: ValidationError): EditEventValidationState {
        val mutable = validationErrorMap.toMutableMap()
        mutable[error.fieldName] = error

        return copy(
            validationErrorMap = mutable
        )
    }

    fun getValidationError(fieldName: String): ValidationErrorValue? =
        validationErrorMap[fieldName]?.value

    fun resetError(fieldName: String): EditEventValidationState {
        val mutable = validationErrorMap.toMutableMap()
        mutable.remove(fieldName)

        return copy(
            validationErrorMap = mutable,
        )
    }
}